export const applicationSelectorQuery = 'application';

export const enum ApplicationEndpoints {
  MultipleApplications = 'application',
  SingleApplication = 'application/{{0}}',
  RefreshApiKey = 'application/{{0}}/refresh-api-key',
  AttachUser = 'application/{{0}}/attach',
  DetachUser = 'application/{{0}}/detach',
}
